import { render, staticRenderFns } from "./AppointmentPopup.vue?vue&type=template&id=1a66c538"
import script from "./AppointmentPopup.vue?vue&type=script&lang=js"
export * from "./AppointmentPopup.vue?vue&type=script&lang=js"
import style0 from "./AppointmentPopup.vue?vue&type=style&index=0&id=1a66c538&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports